import { render, staticRenderFns } from "./OrdersToSend.vue?vue&type=template&id=17a93a0c&"
import script from "./OrdersToSend.vue?vue&type=script&lang=js&"
export * from "./OrdersToSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports